import React from 'react'

import { useHistory } from 'react-router-dom'

import { Container, BackButton } from './styles'

import Icon from '../icon'

import IProps from './props'

const Title = ({ children }: IProps) => {
  const history = useHistory()

  const handleBack = () => {
    history.goBack()
  }

  return (
    <Container>
      <BackButton onClick={handleBack}>
        <Icon name="arrow-left-line" />
      </BackButton>
      {children}
    </Container>
  )
}

export default Title
